import { INK, LINE, MARKS, PAPER } from './theme.ts';

const pill: React.CSSProperties = {
  height: 32,
  padding: '0 10px',
  borderRadius: 10,
  background: PAPER,
  border: `2px solid ${LINE}`,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
  fontWeight: 800,
  fontSize: 12,
};

/**
 * Payment marks. These are third-party trademarks: the production build swaps
 * these in for the official SVGs supplied through each scheme's brand centre —
 * the shapes and palettes here match their placement in the design.
 */
export function PaymentMarks({ compact = false }: { compact?: boolean }) {
  return (
    <div
      style={{ display: 'flex', gap: compact ? 5 : 8, flexWrap: 'wrap', justifyContent: 'center', ...(compact ? { zoom: 0.86 } : null) }}
      aria-label="Accepted payment methods"
    >
      <span style={{ ...pill, fontStyle: 'italic', fontSize: 13, color: MARKS.visa }}>VISA</span>
      <span style={{ ...pill, fontSize: 11 }}>
        <span style={{ display: 'inline-flex' }} aria-hidden="true">
          <span style={{ width: 14, height: 14, borderRadius: '50%', background: MARKS.mastercardRed, display: 'inline-block' }} />
          <span style={{ width: 14, height: 14, borderRadius: '50%', background: MARKS.mastercardOrange, display: 'inline-block', marginLeft: -5 }} />
        </span>
        Mastercard
      </span>
      <span style={{ ...pill, fontStyle: 'italic', fontSize: 13 }}>
        <span style={{ color: MARKS.paypalNavy }}>Pay</span>
        <span style={{ color: MARKS.paypalBlue, marginLeft: -4 }}>Pal</span>
      </span>
      <span style={{ ...pill, background: MARKS.applePay, color: '#fff', border: `2px solid ${INK}` }}>
        <i className="ph-duotone ph-apple-logo" aria-hidden="true" />
        Pay
      </span>
      <span style={pill}>
        <span style={{ color: MARKS.googleBlue }}>G</span>Pay
      </span>
    </div>
  );
}
